import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';
import classNames from 'classnames';
import { isToday } from 'date-fns';
import { useAtom, useAtomValue } from 'jotai';

import { mixpanelEvents, useTrackEvent } from '../../../utils/mixpanel';
import { isActionableViewAtom, selectDateAtom } from '../atoms';

interface Props {
  loading?: boolean;
}

export const ActionableViewButtons = ({ loading }: Props) => {
  const [isActionableView, setIsActionableView] = useAtom(isActionableViewAtom);
  const selectedDate = useAtomValue(selectDateAtom);
  const { trackEvent } = useTrackEvent();

  const handleClick = (value: 'ACTIONABLE' | 'ALL') => {
    setIsActionableView(value === 'ACTIONABLE');
    trackEvent(mixpanelEvents.userChangeActionableView, {
      view: value,
      date: selectedDate,
      isToday: selectedDate ? isToday(selectedDate) : false,
    });
  };

  if (loading) return null;

  return (
    <div className="vai-flex vai-items-center vai-gap-2">
      <p className="vai-typography-small vai-text-slate-500">
        <Trans>Treatments:</Trans>
      </p>
      <div className="vai-isolate vai-flex -vai-space-x-px">
        <Button
          aria-selected={isActionableView}
          className={classNames('vai-rounded-r-none focus:vai-z-10', {
            'hover:vai-text-zinc-500 vai-text-zinc-500': !isActionableView,
            'hover:vai-bg-sapphire-50 vai-bg-sapphire-50 hover:vai-text-sapphire-600 vai-text-sapphire-600':
              isActionableView,
          })}
          onClick={() => handleClick('ACTIONABLE')}
          size="sm"
          variant="outline"
          data-testid="show-actionable-tx-button"
        >
          <p className="vai-typography-small">
            <Trans>Actionable</Trans>
          </p>
        </Button>
        <Button
          aria-selected={!isActionableView}
          className={classNames(
            'vai-rounded-l-none focus:vai-z-10 -vai-space-x-px',
            {
              'hover:vai-text-zinc-500 vai-text-zinc-500': isActionableView,
              'hover:vai-bg-sapphire-50 vai-bg-sapphire-50 hover:vai-text-sapphire-600 vai-text-sapphire-600':
                !isActionableView,
            },
          )}
          onClick={() => handleClick('ALL')}
          size="sm"
          variant="outline"
          data-testid="show-all-tx-button"
        >
          <p className="vai-typography-small">
            <Trans>Show All</Trans>
          </p>
        </Button>
      </div>
    </div>
  );
};
